import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

Font.register({
  family: "Manrope",
  fonts: [
    { src: "/fonts/Manrope-Regular.ttf" },
    { src: "/fonts/Manrope-Bold.ttf", fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Manrope",
     paddingBottom: 90,
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 12,
    textAlign: "center",
  },
  section: {
    marginBottom: 12,
  },
  label: {
    fontSize: 9,
    color: "grey",
  },
  value: {
    fontSize: 11,
    fontWeight: "bold",
  },
  row: {
    flexDirection: "row",
    borderBottom: "1px solid #eee",
    paddingVertical: 6,
  },
  col1: { flex: 2 },
  col2: { flex: 1, textAlign: "right" },
  totalRow: {
    flexDirection: "row",
    borderTop: "2px solid #000",
    marginTop: 10,
    paddingTop: 8,
  },
  totalText: {
    fontSize: 11,
    fontWeight: "bold",
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    marginTop: 10,
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f2f2f2",
    borderBottomWidth: 1,
    borderColor: "#000",
  },

  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
  },

  thName: {
    width: 140,
    // flex: 1,
    padding: 5,
    fontSize: 9,
    fontWeight: "bold",
  },
  // th: {
  //   flex: 1,
  //   padding: 5,
  //   fontSize: 9,
  //   fontWeight: "bold",
  // },

  // td: {
  //   flex: 1,
  //   padding: 5,
  //   fontSize: 9,
  //    textAlign: "right",
  // },

  th: {
    padding: 5,
    fontSize: 8,
    fontWeight: "bold",
  },
  td: {
    padding: 5,
    fontSize: 8,
  },
  tdName: {
    width: 140,
    padding: 5,
    fontSize: 9,
  },
  tdTotalAmount: {
    marginTop: 16,
    marginRight: 12,
    flex: 1,
    padding: 5,
    fontSize: 9,
    textAlign: "right",
  },

  tdRight: {
    flex: 1,
    padding: 5,
    fontSize: 9,
    textAlign: "right",
  },
  footerSpace: {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: 60,
},
footer_image: {
  width: "100%",
  height: 60,
  objectFit: "cover",
},
footerRow: {
  position: "absolute",
  bottom: 64, // ✅ sits just above the 60px footer image
  left: 20,
  right: 20,
  flexDirection: "row",
  justifyContent: "center",
  borderTopWidth: 1,
  borderTopColor: "#ccc",
  paddingTop: 6,
  textAlign:'center'
},
footer: {
  fontSize: 9,
  color: "grey",
},
pageNumber: {
  fontSize: 9,
  color: "grey",
}
});

const COL = {
  account: 0.8,
  name: 1.8,
  contact: 1.2,
  p1: 0.7,
  p2: 0.7,
  p3: 0.7,
  p4: 0.7,
  p5: 0.7,
  p6: 0.7,
  amount: 0.9,
};

const StatementAgeingDocument = ({
  statementDataFromAPI,
  todayDate,
  totalAmount,
  totalP1,
  totalP2,
  totalP3,
  totalP4,
  totalP5,
  totalP6,
}) => {
  console.log("Data in ageing document:", statementDataFromAPI);
  console.log("Data in ageing document todayDate:", todayDate);
  const data = Array.isArray(statementDataFromAPI) ? statementDataFromAPI : [];
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerSpace} fixed>
          {apiPaths_from_local_storage[0].REP_HEADER.includes("data:image/") ? (
            <Image
              src={apiPaths_from_local_storage[0].REP_HEADER}
              style={styles.header_image}
            />
          ) : null}
        </View>
        {/* Title */}
        <Text style={styles.title}>Ageing Statement</Text>

        {/* Account Info */}
        {todayDate && (
          <View style={styles.section}>
            <Text style={styles.label}>Ageing Statement As on</Text>
            <Text style={styles.value}>{todayDate}</Text>

            {/* <Text style={styles.label}>Account Code</Text>
          <Text style={styles.value}>{data?.ACCOUNT}</Text>

          <Text style={[styles.label, { marginTop: 6 }]}>Account Name</Text>
          <Text style={styles.value}>{data?.NAME}</Text> */}
          </View>
        )}

        {/* Aging Table */}
        {/* <View style={styles.section}>
          {[
            ["0-30", data?.P1],
            ["31-60", data?.P2],
            ["61-90", data?.P3],
            ["91-120", data?.P4],
            ["121-150", data?.P5],
            ["150>", data?.P6],
          ].map(([label, value], idx) => (
            <View key={idx} style={styles.row}>
              <Text style={styles.col1}>{label}</Text>
              <Text style={styles.col2}>{Number(value).toFixed(2)}</Text>
            </View>
          ))}
        </View> */}

        <View style={styles.table}>
          {/* HEADER */}
          <View style={styles.tableHeader}>
            <View style={{ flex: COL.account }}>
              <Text style={styles.th}>Account</Text>
            </View>
            <View style={{ flex: COL.name }}>
              <Text style={styles.th}>Name</Text>
            </View>
            <View style={{ flex: COL.contact }}>
              <Text style={styles.th}>Contact</Text>
            </View>
            <View style={{ flex: COL.p1 }}>
              <Text style={[styles.th, { textAlign: "right" }]}>0-30</Text>
            </View>
            <View style={{ flex: COL.p2 }}>
              <Text style={[styles.th, { textAlign: "right" }]}>31-60</Text>
            </View>
            <View style={{ flex: COL.p3 }}>
              <Text style={[styles.th, { textAlign: "right" }]}>61-90</Text>
            </View>
            <View style={{ flex: COL.p4 }}>
              <Text style={[styles.th, { textAlign: "right" }]}>91-120</Text>
            </View>
            <View style={{ flex: COL.p5 }}>
              <Text style={[styles.th, { textAlign: "right" }]}>121-150</Text>
            </View>
            <View style={{ flex: COL.p6 }}>
              <Text style={[styles.th, { textAlign: "right" }]}>{"150 >"}</Text>
            </View>
            <View style={{ flex: COL.amount }}>
              <Text style={[styles.th, { textAlign: "right" }]}>Amount</Text>
            </View>
          </View>

          {/* ROWS */}
          {data?.map((item, index) => (
            <View
              key={index}
              style={[styles.tableRow, { alignItems: "flex-start" }]}
            >
              <View style={{ flex: COL.account }}>
                <Text style={styles.td}>{item?.ACCOUNT}</Text>
              </View>
              <View style={{ flex: COL.name }}>
                <Text style={styles.td}>{item?.NAME}</Text>
              </View>
              <View style={{ flex: COL.contact }}>
                <Text style={styles.td}>{item?.Contact_Info}</Text>
              </View>
              <View style={{ flex: COL.p1 }}>
                <Text style={[styles.td, { textAlign: "right" }]}>
                  {item?.P1}
                </Text>
              </View>
              <View style={{ flex: COL.p2 }}>
                <Text style={[styles.td, { textAlign: "right" }]}>
                  {item?.P2}
                </Text>
              </View>
              <View style={{ flex: COL.p3 }}>
                <Text style={[styles.td, { textAlign: "right" }]}>
                  {item?.P3}
                </Text>
              </View>
              <View style={{ flex: COL.p4 }}>
                <Text style={[styles.td, { textAlign: "right" }]}>
                  {item?.P4}
                </Text>
              </View>
              <View style={{ flex: COL.p5 }}>
                <Text style={[styles.td, { textAlign: "right" }]}>
                  {item?.P5}
                </Text>
              </View>
              <View style={{ flex: COL.p6 }}>
                <Text style={[styles.td, { textAlign: "right" }]}>
                  {item?.P6}
                </Text>
              </View>
              <View style={{ flex: COL.amount }}>
                <Text style={[styles.td, { textAlign: "right" }]}>
                  {Number(item?.AMOUNT).toFixed(2)}
                </Text>
              </View>
            </View>
          ))}
        </View>

        <View style={styles.totalRow}>
          <View style={{ flex: COL.account }}>
            <Text style={styles.totalText}>Total</Text>
          </View>
          <View style={{ flex: COL.name }} />
          <View style={{ flex: COL.contact }} />
          <View style={{ flex: COL.p1 }}>
            <Text style={[styles.td, { textAlign: "right" }]}>
              {Number(totalP1).toFixed(2)}
            </Text>
          </View>
          <View style={{ flex: COL.p2 }}>
            <Text style={[styles.td, { textAlign: "right" }]}>
              {Number(totalP2).toFixed(2)}
            </Text>
          </View>
          <View style={{ flex: COL.p3 }}>
            <Text style={[styles.td, { textAlign: "right" }]}>
              {Number(totalP3).toFixed(2)}
            </Text>
          </View>
          <View style={{ flex: COL.p4 }}>
            <Text style={[styles.td, { textAlign: "right" }]}>
              {Number(totalP4).toFixed(2)}
            </Text>
          </View>
          <View style={{ flex: COL.p5 }}>
            <Text style={[styles.td, { textAlign: "right" }]}>
              {Number(totalP5).toFixed(2)}
            </Text>
          </View>
          <View style={{ flex: COL.p6 }}>
            <Text style={[styles.td, { textAlign: "right" }]}>
              {Number(totalP6).toFixed(2)}
            </Text>
          </View>
          <View style={{ flex: COL.amount }}>
            <Text style={[styles.td, styles.totalText, { textAlign: "right" }]}>
              {Number(totalAmount).toFixed(2)}
            </Text>
          </View>
        </View>

        <View style={styles.footerSpace} fixed>
          {apiPaths_from_local_storage[0]?.REP_FOOTER?.includes(
            "data:image/",
          ) ? (
            <Image
              src={apiPaths_from_local_storage[0].REP_FOOTER}
              style={styles.footer_image}
            />
          ) : null}
        </View>

        {/* FOOTER */}
        <View style={styles.footerRow} fixed>
          {/* <Text style={styles.footer}>
                    Generated: {dayjs().format("DD/MM/YYYY HH:mm")}
                  </Text> */}
          <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
            fixed
          />
        </View>
      </Page>
    </Document>
  );
};

export default StatementAgeingDocument;
